import { useMutation } from '@tanstack/react-query';
import type { SubmitIDPOTPRequestT } from '@lotushealth/lotushealth_js_sdk/schemas';

import { fetchSubmitIdpOtp } from '../api/submitIdpOtp.js';

export interface SubmitIdpOtpVariables {
  data: SubmitIDPOTPRequestT;
}

export function useSubmitIdpOtpMutation() {
  return useMutation({
    mutationKey: ['dosespot-idp', 'submit-otp'],
    mutationFn: async ({ data }: SubmitIdpOtpVariables) => {
      return await fetchSubmitIdpOtp(data);
    },
  });
}
